var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-content"},[_c('div',[_vm._v("Copyright © Dl-zj.com 长沙银拓信息技术有限公司 All Rights Reserved.")]),_c('div',[_vm._v("地址：湖南省长沙市芙蓉区定王台街道芙蓉中路二段98号明城国际中心2009号房")]),_c('div',[_vm._v("电话：0731-85648290")])])
}]

export { render, staticRenderFns }